import { render, staticRenderFns } from "./log-activity.vue?vue&type=template&id=28a88a4a&scoped=true&"
import script from "./log-activity.vue?vue&type=script&lang=js&"
export * from "./log-activity.vue?vue&type=script&lang=js&"
import style0 from "./log-activity.vue?vue&type=style&index=0&id=28a88a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a88a4a",
  null
  
)

export default component.exports